import SubTitle from "../static/SubTitle";

const moduleName = "pengaturanUmumModule";

const state = {
  subMenu: [],
  subTitle: SubTitle(),

  fetching: false,
  response: {},

  epayment: {
    jenis_emoney: 1, //default 1 (limited) || 2 (unlimited),
    // masa_aktif_emoney: "",
    tipe_perpanjangan_masa_aktif_emoney: 1,
    tipe_saldo_expired_emoney: 1,
  },
  penyesuaian: {},
  pengaturanLaporan: {
    sumberDana: [],
    itemBiaya: [],
  },

  reminderOption: [],
  reminderInfo: {},

  customerAmbilDanLunasi: {},

  pelunasanInvoice: {},

  enableWaVerification: false,

  cashbackActivePeriod: 0,

  pointActivePeriod: null,

  notaWaSetting: {},

  pointActiveReminder: null,

  enableServiceRecommendation: false,
};

export { state as default, moduleName };
